import { Button, Checkbox, DatePicker, Divider, message } from 'antd'
import { blockLevel2Processing } from 'api/pgads'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import { getApiTargetInfo, getUnits, UtilityUnitSelection } from 'core'
import { Content, Title } from 'core/screen-util'
import React, { useContext, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import R from 'ramda'

const BlockLevel2Processing = ({ targetInfo, units }) => {
  const [selectedUnit, setSelectedUnit] = useState({})
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning } = useContext(SpinContext)
  const [isSeverity, setIsSeverity] = useState(false)
  const { setError } = useContext(ErrorContext)
  const retrieveTask = _ => {
    if (!selectedUnit.unit) return message.error('Please, Select unit')
    const data = {
      unit: selectedUnit.unit,
      severity: isSeverity ? 1 : 0,
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
    }
    setSpinning(true)
    blockLevel2Processing(targetInfo)(data).fork(setError, dmap => {
      setSpinning(false)
      const { email } = dmap

      message.info(
        'The Process has started. You will be notified when the process is completed'
      )
      if (email) message.info('via email(' + email + ')')
    })
  }

  const rUnitCodeList = useMemo(
    _ =>
      R.compose(
        R.uniq,
        R.map(u => u.utility + (u.runItCode || '').trim()),
        R.filter(u => !!u.runItCode)
      )(units),
    [units]
  )

  const unitfilter = u => rUnitCodeList.includes(u.unitId)

  return (
    <Content>
      <Title>Block Level 2 Processing</Title>
      <Divider />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '700px',
          gap: '10px',
        }}
      >
        <div>Select Unit :</div>
        <UtilityUnitSelection
          unitfilter={unitfilter}
          utility={selectedUnit.utility}
          unit={selectedUnit.unit}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setSelectedUnit({
              utility: value[0],
              unit: value[1],
            })
          }}
        />
        <div>Select Year/Month :</div>
        <DatePicker.MonthPicker
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d.endOf('month'))
          }}
          style={{ width: '90%' }}
        />

        <Checkbox
          checked={isSeverity}
          onChange={e => setIsSeverity(e.target.checked)}
          style={{ marginTop: '20px' }}
        >
          Show Errors Only
        </Checkbox>
        <Divider style={{ width: '90%', minWidth: '90%', maxWidth: '90%' }} />
        <Button
          onClick={() => retrieveTask()}
          style={{ width: '90%' }}
          type="primary"
          // type="danger"
          icon="thunderbolt"
        >
          Run Check
        </Button>
      </div>
    </Content>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(BlockLevel2Processing)
